<app-update-banner />

@if (isAuthenticated()) {
  <router-outlet />
} @else {
  <div class="loading-container">
    <div class="loading-content">
      <div class="loading-spinner"></div>
      <p>Authenticating...</p>
    </div>
  </div>
}
